import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { ReactComponent as Loader } from '@assets/svg/loader.svg';

import {
  LoadingText,
  LoadMore,
} from '@pages/Products/components/ListProducts/ListProducts.styles';

import { LoadMoreContext } from './LoadMoreContext';
import { sizeFromRoller } from './sizeFromRoller';

interface LoadMoreComponentProps {
  content?: React.ReactNode | null;
}
export function LoadMoreComponent(props: LoadMoreComponentProps) {
  const { content } = props;
  const loadMoreCtx = useContext(LoadMoreContext);
  const { ref, inView } = useInView({
    root: loadMoreCtx?.root,
  });

  useEffect(() => {
    if (!loadMoreCtx) return;
    const { hasNextPage, fetchNextPage } = loadMoreCtx;
    if (inView && hasNextPage) fetchNextPage();
  }, [inView, loadMoreCtx?.hasNextPage]);

  if (!loadMoreCtx) return null;
  const { hasNextPage } = loadMoreCtx;

  // The original roller is 17x17 with 2px missing on both sides, hence effectively 13x13
  // However, sizing here is in a 14x14, scaling down gives: 10.7
  const loaderSize = sizeFromRoller();

  function getLoadMoreText() {
    if (!loadMoreCtx) return null;
    if (!hasNextPage) {
      return (
        <LoadMore>
          <LoadingText>{loadMoreCtx.loadMoreText ?? 'End of List'}</LoadingText>
        </LoadMore>
      );
    }

    if (content) return content;
    return (
      <LoadMore>
        <LoadingText>Loading more</LoadingText>
        <Loader width={loaderSize} height={loaderSize} />
      </LoadMore>
    );
  }
  return (
    <div ref={ref} className="loadmore_wrap">
      {getLoadMoreText()}
    </div>
  );
}
